import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';

const imageFileTypes = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/bmp',
    'image/tiff',
    'image/gif'
];

export class ImageUploadFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    maxSizeBytes: number;
    accepts: string;
    buttonLabel: string;
    fileName: string;
    // When used with label, it is for the info circle
    // When used with icon, it is for the icon tooltip
    tooltip?: string;
    imageUploadState?: string;
    icon?: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        maxSizeBytes?: number,
        accepts?: string,
        buttonLabel?: string,
        fileName?: string,
        tooltip?: string,
        icon?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.maxSizeBytes = maxSizeBytes;
        this.accepts = accepts;
        this.buttonLabel = buttonLabel;
        this.fileName = fileName;
        this.tooltip = tooltip;
        this.icon = icon;
    }
}
